import React, { useState } from "react";
import BreadCrumb from "../../components/BreadCrumb";
import OrderComp from "./OrderComp.jsx";
import { useParams } from "react-router-dom";

const AllOrder = () => {
  const { _id } = useParams();
  const [pagination, setPagination] = useState({
    "page": 1,
    "limit": 5,
    "sortOrder": "desc",
    "filter": {}
  })
   
  const handlePagination = (data) => {
    if (data.clearPagination) {
      setPagination(data.clearPagination)
      return
    }
    setPagination((prev) => {
      let copyfilter = { ...prev.filter }
      if (data.filter) {
        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(data.filter)[0]
        } else {
          copyfilter = { ...data?.filter, ...copyfilter }
        }
      }
      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter
      }
    })
  }


  return (
    <div className="pt-4 mr-6">
      <BreadCrumb title={"All Order"} />
      <OrderComp pagination={pagination} handlePagination={handlePagination} orderID={_id&&_id}/>
    </div>
  );
};

export default AllOrder;